import { TvState } from '../useTVStore'

export const selectChannelsData = (state: TvState) => state.channelsData
